import { Dialog, DialogTitle, DialogActions, Button, DialogContent, DialogContentText } from '@mui/material';
import { useTranslation } from 'react-i18next';

type OrginizationResignConfirmProps = {
  modalOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const OrginizationResignConfirm = (props: OrginizationResignConfirmProps) => {
  const { modalOpen, onClose, onConfirm } = props;
  const { t } = useTranslation(['common']);

  return (
    <Dialog open={modalOpen} onClose={() => onClose()} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
      <DialogTitle id='alert-dialog-title'>{t('common:organization:resignConfirm.header')}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>{t('common:organization:resignConfirm.description')}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 0 }}>
        <Button variant='outlined' onClick={() => onClose()}>
          {t('common:button.cancel')}
        </Button>
        <Button onClick={() => onConfirm()} variant='contained' color='primary' disableElevation autoFocus>
          {t('common:button.remove')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
